import * as React from "react";

import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import { ResolvedImage } from "resolvers/data/imageResolver";

import Rating from "../Rating";
import styles from "../Testimonials.module.scss";

const cx = classNames.bind(styles);

interface OverviewProps {
    heading: string;
    logo: ResolvedImage;
    rating: number;
    totalReviews: number;
}

const Overview: React.FC<OverviewProps> = ({ heading, logo, totalReviews, rating }) => {
    return (
        <div className={cx("overview")}>
            <div className={cx("logo")}>
                <Image {...logo} alt={logo.alt || heading} />
            </div>
            <div className={cx("details")}>
                <span className={cx("title")}>{heading}</span>
                <span className={cx("info")}>Reviews {totalReviews.toLocaleString("en-GB")}</span>
            </div>
            <div className={cx("score")}>
                <span className={cx("rating")}>{rating}</span>
                <Rating rating={rating} />
            </div>
        </div>
    );
};

export default Overview;
